export const getLicencas = (state) => state.licencas.lista
export const getIsCarregandoListaLicencas = (state) => state.licencas.isCarregandoLista
export const getLicencaSelecionada = (state) => state.licencas.selecionado
export const getIsCarregandoLicenca = (state) => state.licencas.isCarregandoLicenca
